import { useMemo } from "react";
import { useAppSelector, useAppDispatch } from "../store";
import { toggleTheme, setTheme } from "../store/slices/themeSlice";
import { createLightTheme, createDarkTheme } from "../lib/theme/index";

export function useAppTheme() {
    const dispatch = useAppDispatch();
    const { mode } = useAppSelector((state) => state.theme);

    // Create theme object dynamically based on mode
    const theme = useMemo(() => {
        return mode === 'light' ? createLightTheme() : createDarkTheme();
    }, [mode]);

    const handleToggleTheme = () => {
        dispatch(toggleTheme());
    };

    const handleSetTheme = (newMode: 'light' | 'dark') => {
        dispatch(setTheme(newMode));
    };

    return { 
        theme, 
        mode,
        toggleTheme: handleToggleTheme,
        setTheme: handleSetTheme
    };
}